export default "__VITE_PUBLIC_ASSET__b5212f03__"